import ChatMessageList from "./chat-message-list";

export default ChatMessageList;